<template>
  <require from="swiper/css/swiper.min.css"></require>
  <require from="./swiper.css"></require>

  <div id="${instance}"
       class="swiper-inner instance-${instance}"
       ref="swiperInner"
       click.target="clickedInSlide($event)">
    <slot name="slides"></slot>
  </div>

  <div class="control-${instance}">
    <slot name="controller"></slot>
  </div>


</template>
